import { get } from 'services/request';
import { IHeadingSelect } from 'types/headings';

export default class HeadingSelectModel {
  async get() {
    const headings = await get<IHeadingSelect[]>(`headings/select`);
    return headings.sort((a, b) => (b.uses ?? 0) - (a.uses ?? 0));
  }
}
